import { useMemo } from 'react';
import { useSectionType } from '../sections/SectionTypeContext.tsx';
import { type IWidgetType } from '../widgets/IWidgetType.ts';
import { type Widget } from '../widgets/Widget.ts';
import { type IWidgetDirectiveType } from './IWidgetDirectiveType.ts';
import { WidgetDirectivesRepository } from './WidgetDirectivesRepository.ts';

/**
 * Direttive applicabili al widget, calcolate una sola volta.
 */
export function useWidgetSupportedDirectives(
  widget: Widget | null | undefined,
  widgetType: IWidgetType<Widget> | null | undefined,
): IWidgetDirectiveType<any>[] {
  const { sectionType } = useSectionType();

  return useMemo(() => {
    if (!widget || !widgetType || widgetType.configOptions?.hideDirectives)
      return [];
    // Ordine di registrazione nel repository: l'ordine visivo delle card è
    // deciso dagli slot/order dichiarati dai configComponent (slot-fill).
    return WidgetDirectivesRepository.getAll()
      .filter(directive => directive.allowsWidget(widget, widgetType))
      .filter(directive => {
        if (!directive.supportedSectionTypes) return true;
        return directive.supportedSectionTypes.includes(sectionType);
      });
  }, [widget, widgetType, sectionType]);
}
